module.exports = __webpack_public_path__ + "img/acacia-swimming-pool.9e87c550.webp";